import { useCallback, useMemo, useState } from 'react';
import { Alert, Form, FormInput } from 'shards-react';

const ManualReference = ({
    approved = true,
    references = [],
    addReference = () => null,
}) => {
    const [value, setValue] = useState(() => '');
    const isExisting = useMemo(
        () => references.includes(value),
        [references, value]
    );

    const updateValue = useCallback((e) => {
        const newValue = e?.target?.value ?? '';
        return setValue(() => newValue);
    }, []);

    const returnValue = useCallback(
        (e) => {
            e.preventDefault();
            const result = value.trim();
            if (result === '' || isExisting) return null;
            let rmSpacesAndSlashes = result.replace(/ |\/|\\/gi, '');
            addReference(rmSpacesAndSlashes);
            return setValue(() => '');
        },
        [value, isExisting, addReference]
    );

    const formWidth = useCallback(() => {
        const viewPort = window.innerWidth;
        if (viewPort <= 950) {
            return 6;
        } else {
            return 30;
        }
    }, []);

    if (approved) return null;

    return (
        <div className='d-flex'>
            <div style={{ minWidth: `${formWidth()}rem` }}>
                <Form onSubmit={returnValue}>
                    <FormInput
                        data-test='ref-manual-input'
                        type='text'
                        placeholder='Neue Referenz einfügen'
                        pattern='\S+'
                        title='Es ist kein Leerzeichen erlaubt!'
                        onChange={updateValue}
                        value={value}
                        invalid={isExisting}
                    />
                </Form>
            </div>
            {value && !isExisting && (
                <div
                    style={{
                        zIndex: 10,
                        cursor: 'pointer',
                    }}
                    className={`position-relative px-3 ${
                        references.length === 1 && 'border-right border-success'
                    }`}
                    title='Zum Hinzufügen anklicken!'
                    onClick={returnValue}
                >
                    <button
                        data-test='ref-manual-add-btn'
                        className='btn btn-outline-success rounded-pill'
                    >
                        Hinzufügen
                    </button>
                </div>
            )}
            <Alert
                theme='danger'
                style={{ zIndex: '10' }}
                className='position-absolute mt-5 font-weight-bold'
                open={isExisting}
            >
                Referenz existiert!
            </Alert>
        </div>
    );
};

export default ManualReference;
